import React from "react";
import { Tooltip } from "@/components/Tooltip";

interface TruncatedTooltipTextProps {
    text: string;
    tooltip?: string;
    className?: string;
}

export const TruncatedTooltipText: React.FC<TruncatedTooltipTextProps> = ({
    text,
    tooltip = "",
    className = "",
}) => (
    <Tooltip title={tooltip && tooltip?.length > 0 ? tooltip : text}>
        <span className={`block min-w-0 truncate ${className}`}>{text}</span>
    </Tooltip>
);

export default TruncatedTooltipText;
